import {BaseDesignBlockFile} from "../types/design-block-files.types";
import {defaultFileParams} from "../../../../../../../core/models/default-file-params";

export const defaultBaseDesignBlockFile: BaseDesignBlockFile = {
  id: 0,
  fileName: '',
  file: defaultFileParams
}
